// "Parking in Malta, made easier." — three use cases + list-your-space CTA.
// Compact, mobile-first, reuses the existing landing visual language.

import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Radio, Compass, Warehouse, ArrowRight } from "lucide-react";

const CASES = [
  {
    icon: Radio,
    title: "Share a Spot",
    text: "Leaving? Drop your spot so the next driver can take it instead of circling.",
  },
  {
    icon: Compass,
    title: "Find Parking",
    text: "See live spots near you on the map and claim one before it disappears.",
  },
  {
    icon: Warehouse,
    title: "Rent Private Parking",
    text: "Browse private garages and driveways offered by owners across Malta.",
  },
];

export default function UseCases() {
  return (
    <section className="py-14 md:py-20 border-t border-white/5" data-testid="use-cases">
      <div className="max-w-7xl mx-auto px-5 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
        >
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#ccff00] font-semibold">
            What SpotDrop does
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold mt-2 leading-tight">
            Parking in Malta, made easier.
          </h2>
        </motion.div>

        <div className="mt-6 grid gap-3 sm:grid-cols-3">
          {CASES.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.06 }}
              className="p-4 rounded-2xl bg-[#141416] border border-white/10"
              data-testid={`use-case-${i}`}
            >
              <div className="w-9 h-9 rounded-xl bg-[#ccff00]/10 border border-[#ccff00]/30 flex items-center justify-center">
                <c.icon className="w-4 h-4 text-[#ccff00]" />
              </div>
              <div className="text-base md:text-lg font-heading font-semibold mt-3">{c.title}</div>
              <p className="text-sm text-zinc-400 mt-1 leading-relaxed">{c.text}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-4 p-4 rounded-2xl bg-[#ccff00]/[0.06] border border-[#ccff00]/25 flex flex-col sm:flex-row sm:items-center gap-3">
          <p className="text-sm text-zinc-200 flex-1 leading-snug">
            Have an unused parking space? List it on SpotDrop.
          </p>
          <Link
            to="/app"
            className="shrink-0 h-11 px-5 rounded-full bg-[#ccff00] text-[#0a0a0c] text-sm font-semibold inline-flex items-center justify-center gap-2 active:scale-[0.98] transition-transform"
            data-testid="list-space-cta"
          >
            List your space
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
